<template>
  <div class="row">
    <div class="col-4 offset-4 mt-5">
      <h2>Nastavení příjmu potvrzení o platbách</h2>
      <h3>Konfigurace emailového účtu</h3>
      <div class="row my-3">
        <div class="col-lg-2">
          <label for="gender">Uživatel:</label>
        </div>
        <div class="col-lg-10">
          <b-form-input
            class="myInput"
            :type="'text'"
            v-model="user" />
        </div>
        <div class="col-4 offset-4 mt-2">
          <b-button
            type="submit"
            class="myButton align-middle m-2"
            :disabled="isAuthorized"
            @click="authorize()">
            Autorizovat
          </b-button>
          <b-button
            type="submit"
            class="myButton align-middle m-2"
            :disabled="!isAuthorized"
            @click="logout()">
            Odhlásit
          </b-button>
        </div>
      </div>
      <div class="row my-3">
        <b-list-group class="payment-notices-list">
          <b-list-group-item
            v-for="(notice, index) in paymentNoticeResults"
            :key="notice.id">
            {{ index + 1 }}: {{ formatDate(notice.paymentNotice.receivedAt) }}
            -- {{ notice.paymentNotice.name }}
            -- {{ notice.paymentNotice.variableSymbol }}
            -- {{ notice.paymentNotice.accountNumber }}
            -- {{ notice.paymentNotice.amount }}
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      user: '',
      logged: false,
      paymentNoticeResults: []
    };
  },
  computed: {
    isAuthorized() {
      return this.logged;
    }
  },
  mounted() {
    this.getLoggedUser().then(() => {
      this.getLastPaymentNotices();
    });
  },
  methods: {
    authorize() {
      this.axios.get('ms-identity/authorize-request-url/mail').then((response) => {
        console.log(response);
        window.location.href = response.data.result;
      });
    },
    logout() {
      this.axios.get('ms-identity/logout').then((response) => {
        console.log(response);
        this.reset();
      });
    },
    getLoggedUser() {
      return this.axios.get('ms-identity/user').then((response) => {
        console.log(response);
        this.user = response.data.user;
        this.logged = response.data.logged;
      });
    },
    getLastPaymentNotices() {
      return this.axios.get('ms-identity/payment-notices').then((response) => {
        console.log(response);
        this.paymentNoticeResults = response.data.result;
      });
    },
    reset() {
      this.user = '';
      this.paymentNoticeResults = [];
      this.logged = false;
    },
    formatDate(date) {
      return this.$moment(date).format('LLLL');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.payment-notices-list {
  .list-group-item {
    background-color: inherit;
  }
}
</style>
